import { render, staticRenderFns } from "./TargetSelectors.vue?vue&type=template&id=9ad1fa56&scoped=true"
import script from "./TargetSelectors.vue?vue&type=script&lang=js"
export * from "./TargetSelectors.vue?vue&type=script&lang=js"
import style0 from "./TargetSelectors.vue?vue&type=style&index=0&id=9ad1fa56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad1fa56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ad1fa56')) {
      api.createRecord('9ad1fa56', component.options)
    } else {
      api.reload('9ad1fa56', component.options)
    }
    module.hot.accept("./TargetSelectors.vue?vue&type=template&id=9ad1fa56&scoped=true", function () {
      api.rerender('9ad1fa56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/TargetSelector/TargetSelectors.vue"
export default component.exports